import CrownForm from "./scripts/CrownForm";
import "./styles/pages/_installers.scss";
import "./styles/pages/_gallery.scss";

const form = document.querySelector<HTMLFormElement>(".installers__form");
if (form) {
  new CrownForm({
    el: form,

    url: "/wp-content/themes/rockdoor/api/Enquiry.php",

    button: {
      submittingText: "Sending...",
      defaultText: "Send enquiry",
    },

    success() {
      const successContainer = document.querySelector<HTMLParagraphElement>(
        ".installers__alert--success"
      );

      form.remove();
      successContainer?.classList.add("installers__alert--show");
      successContainer?.scrollIntoView(false);
    },
  });

  const doorIdField = form.querySelector<HTMLInputElement>("#door_id");
  if (doorIdField) {
    doorIdField.value = window.sessionStorage.getItem("door_id") || "";
  }
}
